import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Flex,
  Text,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  useToast,
  Button,
  Icon,
  Circle,
} from '@chakra-ui/react'
import React, { useRef } from 'react'
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa'
import { LuCopy } from 'react-icons/lu'

interface ShareModalProps {
  isOpen: boolean
  onClose: () => void
  shareUrl: string
}

const ShareModal: React.FC<ShareModalProps> = ({ isOpen, onClose, shareUrl }) => {
  const toast = useToast()
  const textInputRef = useRef<HTMLInputElement | null>(null)

  const handleWhatsAppShare = () => {
    const message = `Hola, te comparto este aviso de EDUprivada que quizás te pueda interesar ${shareUrl}`
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, '_blank')
  }

  const handleEmailShare = () => {
    const subject = 'Te compartieron una nueva oferta laboral, ¡No te la pierdas!'
    const body = `Hola, te comparto este aviso de EDUprivada que quizás te pueda interesar ${shareUrl}`
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      body,
    )}`
    window.open(mailtoLink, '_blank')
  }

      const handleCopy = async () => {
        try {
          // Usamos la moderna API del Clipboard
          await navigator.clipboard.writeText(shareUrl);
          console.log('Copiado exitosamente:', shareUrl);
          toast({
            title: 'Enlace copiado',
            status: 'success',
            duration: 2000,
          });
        } catch (err) {
          console.error('Error al copiar:', err);
          // Si falla, mostramos un mensaje al usuario
          toast({
            title: 'No se pudo copiar automáticamente',
            description: 'Por favor, selecciona el texto y copia manualmente (Ctrl+C)',
            status: 'warning',
            duration: 3000,
          });
        }
      };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='sm'>
      <ModalOverlay />
      <ModalContent p={4} borderRadius='lg' bg='white'>
        <ModalHeader textAlign='center'>Compartí este aviso</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex justify='center' gap={4} my={6}>
            <Circle
              as='button'
              size='50px'
              bg='#25D366'
              color='white'
              onClick={handleWhatsAppShare}
              _hover={{ bg: '#1ea952' }}
            >
              <Icon as={FaWhatsapp as React.ElementType} boxSize={6} />
            </Circle>
            <Circle
              as='button'
              size='50px'
              bg='#0078FF'
              color='white'
              onClick={handleEmailShare}
              _hover={{ bg: '#0056b3' }}
            >
              <Icon as={FaEnvelope as React.ElementType} boxSize={6} />
            </Circle>
          </Flex>
          <Text fontSize='sm' fontWeight='medium' mb={2}>
            Copiar el enlace
          </Text>
          <InputGroup size='md'>
            <Input value={shareUrl} isReadOnly pr='4.5rem' borderRadius='md' bg='gray.50' />
            <InputRightElement width='4.5rem'>
              <IconButton
                h='1.75rem'
                size='sm'
                onClick={handleCopy}
                aria-label='Copiar enlace'
                icon={<Icon as={LuCopy as React.ElementType} boxSize={4} />}
                variant='ghost'
              />
            </InputRightElement>
          </InputGroup>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ShareModal
